import styled, { keyframes, css } from 'styled-components';
import { Card, Button, Steps, Typography, Collapse,Upload, Carousel } from 'antd';
import {MySegmented} from "../../components";

const isMobile = window.innerWidth < 768;

export const ButtonContainer = styled.div`
  background-color: white;
  width: ${isMobile ? '38px' : '48px'};
  height: ${isMobile ? '38px' : '48px'};
  border-radius: 50%;
  border: 2px solid rgba(229, 233, 242, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(0, 189, 244, 1);
    & svg {
      color: #fff;
    }
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 50px;
  padding: 5px 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 100%;
`;

export const SearchIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: rgba(231, 250, 255, 1);
  
  svg {
    font-size: 24px;
    color: rgba(0, 141, 210, 1); 
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  width: ${isMobile ? '40%' : 'auto'};
  border: none;
  outline: none;
  padding: 10px;
  font-size: 18px;
  line-height: 24px;
  background-color: transparent;
`;

export const SearchButton = styled.button`
  background-color: #00bfff;
  color: white;
  border: none;
  padding: ${isMobile ? '0' : '10px 20px'};
  border-radius: ${isMobile ? '50%' : '40px'};
  font-size: ${isMobile ? '0' : '18px'};
  cursor: pointer;
  width: ${isMobile ? '50px' : 'auto'};
  height: ${isMobile ? '50px' : 'auto'};
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: #00a3e0;
  }
`;

export const StyledCarousel = styled(Carousel)`
    .slick-next {
    top: 40% !important;
    background: rgba(150, 155, 171, 1) !important;
    right: 35px !important;
    width: 60px !important;
    height: 60px !important;
    opacity: 0.90 !important;
    border-radius: 12px;
    }

    .slick-prev {
    top: 40% !important;
    background: rgba(150, 155, 171, 1) !important;
    opacity: 0.90 !important;
    width: 60px !important;
    height: 60px !important;
    border-radius: 12px;
    }

    .slick-next::after {
    top: 40% !important;
    left: 35% !important;
    }

    .slick-prev::after {
    top: 40% !important;
    left: 40% !important;
    }
`;